<div class="passive-perception"
     *ngIf="character"
>
  <div class="label"
       [innerText]="'Passive Perception'"
  ></div>
  <div class="value"
       [innerText]="passivePerception"
  ></div>
</div>
